import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ProductCard/ProductCardTimelineItem.tsx
import { Skeleton } from "../../../primitive/Skeleton/Skeleton.mjs";
import { ProductCard } from "./ProductCard.mjs";
import { jsx, jsxs } from "react/jsx-runtime";
function ProductCardSkeleton({ hasAddToCart }) {
  return /* @__PURE__ */ jsxs("div", { className: "buyscout-product-card-single-skeleton", children: [
    /* @__PURE__ */ jsx(Skeleton, { variant: "rect", className: "buyscout-product-card-single-skeleton-image" }),
    /* @__PURE__ */ jsxs("div", { className: "buyscout-product-card-single-skeleton-info", children: [
      /* @__PURE__ */ jsxs("div", { className: "buyscout-product-card-single-skeleton-title", children: [
        /* @__PURE__ */ jsx(Skeleton, { width: "85%" }),
        /* @__PURE__ */ jsx(Skeleton, { width: "60%" })
      ] }),
      /* @__PURE__ */ jsx(Skeleton, { width: "45%", className: "buyscout-product-card-single-skeleton-price" }),
      hasAddToCart && /* @__PURE__ */ jsx(Skeleton, { variant: "rect", width: 100, className: "buyscout-product-card-single-skeleton-cart" })
    ] })
  ] });
}
function ProductCardTimelineItem({ product, loading = false, storeDomain, onAddToCart }) {
  if (!loading && !product) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "buyscout-timeline-product-card", "aria-busy": loading || void 0, children: loading ? /* @__PURE__ */ jsx(ProductCardSkeleton, { hasAddToCart: !!onAddToCart }) : /* @__PURE__ */ jsx(ProductCard, { product, storeDomain, onAddToCart }) });
}
export {
  ProductCardTimelineItem
};
//# sourceMappingURL=ProductCardTimelineItem.mjs.map